/**
 * 门票 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const smartticket = {
    // 列表
    list(params) {
        return axios.get(api + 'smartticket/list', { params: params })
    },
    // 添加
    create(params) {
        return axios.post(api + 'smartticket/create', qs.stringify(params))
    },
    // 修改
    edit(params) {
        return axios.post(api + 'smartticket/edit', qs.stringify(params))
    },
    // 单个查看
    detail(params) {
        return axios.get(api + 'smartticket/detail', { params: params })
    },
    status(params) {
        return axios.post(api + 'smartticket/status', qs.stringify(params))
    },
    // 删除
    remove(params) {
        return axios.post(api + 'smartticket/remove', qs.stringify(params))
    },
}

// 导出接口
export default smartticket
